export default __webpack_public_path__ + "static/media/controlecx.386b1dfe.webp";